import { Component, ChangeDetectorRef } from '@angular/core';
import { AuthenticationService, TestData, CandidateInformation } from '../services/authentication.service';
import { Router } from '@angular/router';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MediaMatcher } from '@angular/cdk/layout';
import { TestTakerService } from '../services/test_taker.service';
import { HttpClient } from '@angular/common/http';
import { report, ReportService } from '../services/report.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CollegeService, College_Names } from '../services/College_name.service';
import { YearService } from '../services/year.service';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './candidate.component.html',
  styleUrls: ['./candidate.component.scss']
})

export class UploadCandidateComponent {
  report_details: report = { College_Id: '', Year_Id: '', Question_Set: '' };
  result: string[];
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  userEvaluator: boolean;
  display: boolean;
  overall: boolean;
  questionset: boolean;
  scheduletest: boolean;
  evaluate: boolean;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  links = ['Super Admin', 'Admin', 'Test Scheduler', 'Test Taker'];
  email;
  user;
  fname;
  lname;
  columns: string[];
  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  college_set: College_Names = {
    college_name: ''
  }
  submitted = false;
  registerForm: FormGroup;

  information: CandidateInformation = {
    college_name: '',
    academic_year: ''
  };
  info;
  file;
  name;
  uploadedFiles: Array<File>;
  data: string;
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  college: any;
  options: string[] = ['One', 'Two', 'Three'];
  year: any;

  constructor(private auth: AuthenticationService, private router: Router, private formBuilder: FormBuilder, private http: HttpClient,
    private testtakerservice: TestTakerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private reportservice: ReportService, private fs: CollegeService, private ys: YearService) {
    this.getAccess();
    this.simpletest();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      college_name: ['', Validators.required],
      academic_year: ['', Validators.required],
      data: ['', Validators.required]
    });
    this.CollegeName()
    this.Academicyear()
  }

  get f() {
    return this.registerForm.controls;
  }

  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }




  simpletest() {
    this.testtakerservice.test_taker(this.test).subscribe(
      (data) => {

        this.result = data.results;
        this.user = sessionStorage.getItem('user');
        this.fname = sessionStorage.getItem('fname');

        this.lname = sessionStorage.getItem('lname');


        if (this.user === '2') {

          this.userAdmin = true;
          this.userSuperAdmin = false;
          this.userTestScheduler = true;
        } else if (this.user === '1') {
          this.userAdmin = true;
          this.userSuperAdmin = true;
          this.userTestScheduler = true;
        } else if (this.user === '3') {
          this.userAdmin = false;
          this.userSuperAdmin = false;
          this.userTestScheduler = true;
        } else if (this.user === '4') {
          this.userAdmin = false;
          this.userSuperAdmin = false;
          this.userTestScheduler = false;
          this.userTestTaker = true;
          return this.result;
        }
      },
      err => {
        console.error(err);
      }
    );
  }

  // fileChange(element) {
  //   this.uploadedFiles = element.target.files;
  //
  //
  //
  //   this.file = this.uploadedFiles[0].name;
  // }

  Selectfile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.name = file;
    }
  }

  CollegeName() {
    this.fs.College_Name(this.college_set).subscribe(
      (data) => {

        this.college = data.results;
        for (var i = 0; i < this.college.length; i++) {
          this.options.push(this.college[i].College_Name)
        }


      },
      err => {
        console.error(err);
      }
    );
  }

  Academicyear() {
    this.fs.academicyear(this.college_set).subscribe(
      (data) => {

        this.year = data.results;
      },
      err => {
        console.error(err);
      }
    );
  }


  upload() {
    this.submitted = true;

    let info = this.information;
    console.log("thios.info",this.information)
    // let formData = new FormData();
    //

    var formData: any = new FormData();
    formData.append('name', this.information.college_name);
    formData.append('year', this.information.academic_year)
    formData.append('file', this.name);
    console.log("this.name",this.name)

    console.log("formData",formData)
    this.http.post('/users/upload', formData, { responseType: 'json' })
      .subscribe((response) => {
        const res = (typeof response === 'string') ? JSON.parse(response) : response;
        //

        if (res.code == 200) {
          
          Swal.fire({
            title: 'Success',
            text: 'Candidates Uploaded Successfully',
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/test_taker']);
            }
          })
        }
        else {
          
          Swal.fire({
            title: 'Alert',
            text: 'Upload Failed',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              this.download_temp_validate_candidates_upload()
              // this.router.navigateByUrl('/test_scheduler');
            }
          })
        }
      },

        (error) => console.error(error));
    //  alert("Upload failed")


  }



  download_temp_validate_candidates_upload() {
    // this.data=true;
    //alert("Inside downtemp")
    this.reportservice.download_temp(this.report_details).subscribe(
      (data) => {


        var csv = '';
        data.results.forEach((row) => {


          var array = Object.values(row);

          csv += array.join(',');
          csv += "\n";
        });


        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'report.csv';
        hiddenElement.click();

        // this.dataSource = new MatTableDataSource(this.reportdetails);
        // this.dataSource.sort=this.sort;
        // setTimeout(() => this.dataSource.paginator = this.paginator);
        //

      },
      err => {
        console.error(err);
      }
    );
  }

}
